<template>
    <section>
        <div class="container">
            <h2>비밀번호 변경</h2>
            <hr>
            <div class="container">
                <div class="form-group input-group">
                    <div>
                        <p>기존 비밀번호</p>

                        <input type="password" class="form-control" ref="password" v-model="member.password" >
                    </div>
                </div>
                <div class="form-group input-group">
                    <div>
                        <p>변경할 비밀번호</p>

                        <input type="password" class="form-control" ref="password" v-model="password_new" >
                    </div>
                </div>
                <div class="form-group input-group">
                    <div>
                        <p>비밀번호 확인</p>

                        <input type="password" class="form-control" ref="password" v-model="password_re" >
                    </div>
                </div>
                <div class="container text-center">
                    <button class="btn btn-outline-primary my-5" @click="$router.go(-1)" style="margin-right: 10px">돌아가기</button>
                    <button class="btn btn-outline-primary my-5" @click="changePassword(password_new)">비밀번호 변경</button>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

    export default {
        name: 'changePW',
        components: {
        },
        data() {
            return {
                member:{
                    id : 0,
                    isWithdraw: false,
                    withdrawReason : '',
                    password:process.env.NODE_ENV == 'development' ? "11111111": ""
                },
                withdrawReasonText: "",
                textReadonly : true,
                password_new: "",
                password_re: "",

            };
        },
        methods: {

            changePassword(password) {

                let me = this;

                if (password == '') {
                    this.$root.$children[0].commonDialog(this.requireInfoModalTitle, '비밀번호를 입력하세요.');
                    return;
                } else if (password.length < 8 || password.length > 12) {
                    this.$root.$children[0].commonDialog(this.requireInfoModalTitle, '비밀번호는 특수문자 포함 8자와 12자 사이로 입력해주세요.');
                    return;
                } else if (password != this.password_re){
                    this.$root.$children[0].commonDialog(this.requireInfoModalTitle, '새로운 비밀번호가 일치하지 않습니다.');
                    return;
                }

                this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/change/password?tmp_password=${password}`, this.member)
                    .then(function (res) {
                        let result = res.data;
                        if(result) {
                            me.$root.$children[0].commonDialog('알림','비밀번호 변경이 완료되었습니다.');
                            me.$router.go(-1);
                        }
                        else {
                            me.checkPasswordRemind();
                        }
                        //me.$auth.logout();
                    }).catch(function (error) {
                    me.$root.$children[0].commonDialog('알림','비밀번호 변경에 실패하였습니다.');
                    console.log(error);
                });
            },
            checkPasswordRemind() {
                this.member.password = '';
                this.$root.$children[0].commonDialog('알림','비밀번호 변경에 실패하였습니다. 기존 비밀번호를 확인해주세요.');
                this.$refs.password.focus();
                return;
            },
        },
        computed: {},
        mounted() {
            this.member.id = this.$auth.user().id;
        }
    };
</script>
<style scoped>
    hr{border-top: 3px solid #0077ff;}
</style>